// extracted by mini-css-extract-plugin
export default {"postPage":"_1uhkm","emptyState":"_1k78V","recentPosts":"a8ShA"};